import React from 'react';
import { createContext } from 'react';
import { FilterStoreContextType } from 'libs/end-to-end/src/filters-v2/types/filters-v2.types';

export const FilterStoreContext = createContext<FilterStoreContextType>({
  state: { selections: [] },
  setState: () => {},
});
